export const initProjectQuota = {
  cpu: 200,
  memory: 512,
  storage: 2000,
  image: 50,
  count: 200,
  port: 50,
  eport: 50,
  isolated_device: 50,
  eip: 20,
  snapshot: 50,
  instance_snapshot: 50,
  bucket: 10,
  object_gb: 200,
  object_cnt: 10,
  secgroup: 50,
  rds: 50,
  cache: 50,
  loadbalancer: 50,
}

export const initDomainQuota = {
  cpu: 2000,
  memory: 4096,
  storage: 20000,
  image: 500,
  count: 500,
  port: 500,
  eport: 500,
  isolated_device: 500,
  eip: 200,
  snapshot: 200,
  instance_snapshot: 200,
  bucket: 100,
  object_gb: 2000,
  object_cnt: 100,
  secgroup: 50,
  rds: 50,
  cache: 50,
  loadbalancer: 50,
  cloudaccount: 20,
  globalvpc: 10,
  group: 500,
  policy: 100,
  project: 100,
  role: 100,
  user: 100,
  host: 500,
  vpc: 500,
}

export const QUOTA_KEYS = {
  HOST: ['count', 'cpu', 'memory', 'storage', 'isolated_device'],
  REGION: ['port', 'eport', 'eip', 'snapshot', 'instance_snapshot', 'bucket', 'object_cnt', 'object_gb', 'rds', 'cache', 'loadbalancer'],
  IMAGE: ['image'],
  PROJECT: ['secgroup'],
}
